import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { FlexBetween } from '../../../global/commonStyle';

const Timer = styled.div`
  width: 186px;
  padding-inline: var(--space-12);
  z-index: var(--z-index-999);
  background-color: var(--background-navbar);
  ${mobile_xl(css`
    width: 100%;
    padding: var(--space-0);
  `)}
`;

const Action = styled.div`
  ${FlexBetween}
  gap: var(--space-4);
  width: auto;
  span {
    ${Typography.body_md};
    color: var(--text-primary);
    width: 90px;
  }
  .time-icon {
    path {
      stroke: var(--text-primary);
    }
  }
  ${mobile_xl(css`
    span {
      width: auto;
    }
  `)}
`;

const Check = styled.div`
  display: flex;
  .svg-icon {
    opacity: 0.5;
  }
`;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  border: 0.5px solid transparent;
  cursor: pointer;
  .top-section {
    display: none;
  }
  &:hover {
    border: 0.5px solid var(--border-primary);
    border-radius: var(--border-radius-8);
    background: var(--background-primary);
    box-shadow: var(--shadow-card);
    .top-section {
      display: flex;
    }
  }
  ${mobile_xl(css`
    width: 100%;
    border: 0.5px solid var(--border-primary);
    border-radius: var(--border-radius-8);
    background: var(--background-tertiary);
    box-shadow: var(--shadow-card);
    .top-section {
      display: flex;
    }
  `)}
`;

const Top = styled.div`
  display: flex;
  gap: var(--space-4);
  padding: var(--space-6) var(--space-8) var(--space-4);
  cursor: pointer;
  &:hover {
    background-color: var(--neutral-secondary);
    border-radius: var(--border-radius-8) var(--border-radius-8) var(--border-radius-0) var(--border-radius-0);
  }
`;

const ActiveTaskName = styled.p`
  color: var(--text-primary);
  margin: var(--space-0);
  ${Typography.body_sm_medium}
  word-break: break-word;
`;

const Bottom = styled.div`
  ${FlexBetween}
  padding: var(--space-6) var(--space-8);
`;

export { Timer, Action, Check, Box, Top, Bottom, ActiveTaskName };
